import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { useSelector } from 'react-redux'

import { buildTranslate } from 'locales'
import {
  PickerSliceState,
  selectGroupLevel1Label,
  selectGroupSubtitle,
  selectGroupTitle,
} from 'slices/aiSegmentBuilder/picker'

import TopOperatorContainer from './TopOperator.container'

const t = buildTranslate('components.ai.picker.group_header')

type RootState = { picker: PickerSliceState }

type Props = {
  groupId: string
  disabled: boolean
}

/** A picker group's title, and its subtitle with the top operator in place of {operator} */
const PickerGroupHeaderContainer = ({ groupId, disabled }: Props) => {
  const [css] = useStyletron()
  const title = useSelector((state: RootState) =>
    selectGroupTitle(state, groupId)
  )
  const subtitle = useSelector((state: RootState) =>
    selectGroupSubtitle(state, groupId)
  )
  const level1Label = useSelector((state: RootState) =>
    selectGroupLevel1Label(state, groupId)
  )

  const subtitleClassName = css({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginTop: '4px',
  })

  const renderSubtitle = () => {
    if (!subtitle) {
      return (
        <>
          {t('fallback_before')}{' '}
          <TopOperatorContainer groupId={groupId} disabled={disabled} />{' '}
          {t('fallback_after', { label: level1Label.toLowerCase() })}
        </>
      )
    }
    const parts = subtitle.split('{operator}')
    if (parts.length === 1) {
      return <>{subtitle}</>
    }
    return (
      <>
        {parts[0]}
        <TopOperatorContainer groupId={groupId} disabled={disabled} />
        {parts[1]}
      </>
    )
  }

  return (
    <div className="mb-m">
      <Text.Header4 tag="h3" color="grey90">
        {title}
      </Text.Header4>
      <Text.BodyText4 tag="p" color="grey70" className={subtitleClassName}>
        {renderSubtitle()}
      </Text.BodyText4>
    </div>
  )
}

export default PickerGroupHeaderContainer
